import { getAPI, postAPI, putAPI, deleteAPI } from "../../api/api";
import { REACT_APP_CANDIDATE_FRELLANCER, REACT_APP_JOB, REACT_APP_TIMESHEET, REACT_APP_CONTRACT, REACT_APP_CUSTOMER } from "../../utils/common";
import { REACT_APP_RECRUITER } from "../../utils/common";


export async function updateAvailablity(body: any) {
    const Details = putAPI(REACT_APP_CANDIDATE_FRELLANCER + '/updateavailability', body)
    return Details
}

export async function contractMetadata(body: any) {
    const Details = postAPI(REACT_APP_CONTRACT + '/insertContractMetadata', body)
    return Details
}

export async function getProjects(companyId: string) {
    const Details = getAPI(REACT_APP_CUSTOMER + `/project-list/${companyId}`)
    return Details
}

export async function getProjectDetails(projectId: string) {
    const Details = getAPI(REACT_APP_JOB + `/projectDetails/${projectId}`)
    return Details
}

export async function updatePriority(body: any) {
    const Details = putAPI(REACT_APP_JOB + '/job-priority', body)
    return Details

}
export async function getAllocatedto() {
    const Details = getAPI(REACT_APP_RECRUITER + "/list")
    return Details
}

export async function updateAllocationPosition(body: any) {
    const Details = postAPI(REACT_APP_JOB + '/updateJobsAllocation', body)
    return Details
}

export async function updateAllocationResource(body: any) {
    const Details = putAPI(REACT_APP_CANDIDATE_FRELLANCER + '/updateallocatedto', body)
    return Details
}
export async function updateCandidateStatus(body: any) {
    const Details = postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/updatecandidatestatus', body)
    return Details
}

export async function getPositionsDetails(jobId: string) {
    const Details = getAPI(REACT_APP_JOB + `/${jobId}`)
    return Details
}

export async function deleteDraftFreelancer(candidateId: string) {
    const Details = deleteAPI(REACT_APP_CANDIDATE_FRELLANCER + `/deleteDraftFreelancer/${candidateId}`)
    return Details
}

export async function updateProject(body: any) {
    const Details = postAPI(REACT_APP_JOB + '/updateProject', body)
    return Details
}

export async function updateInvoiceRaised(body: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + '/invoiceStatus', body)
    return Details
}


